import { error, finish } from '../../../../modules/ladders/actions/masterLadder/createPrice';
import api from '../../../../api';

export function request(dispatch, { price }) {
    api.post(`/ladders/masterladder/create-price`,  price, { cache: true }).then(
        masterladder => dispatch(finish(masterladder)),
        ({ errors }) => dispatch(error(errors))
    );
}
